module.exports = __webpack_public_path__ + "img/ticket2.804c54fc.svg";